module.exports = __webpack_public_path__ + "img/pr-2.2d4f7107.png";